/**
 * Utilitaires bannières (format API) :
 * { id, title, section, type, startDate: "YYYY-MM-DD", endDate: null|string, isActive, imagePath, ... }
 */

/** Parse une date calendaire sans décalage UTC (ex. "2026-06-10"). */
export function parseBannerDate(value) {
  if (value == null || value === '') return null;

  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return null;
    return new Date(value.getFullYear(), value.getMonth(), value.getDate());
  }

  const str = String(value).trim();
  const isoDay = /^(\d{4})-(\d{2})-(\d{2})/.exec(str);
  if (isoDay) {
    const year = Number(isoDay[1]);
    const month = Number(isoDay[2]) - 1;
    const day = Number(isoDay[3]);
    const parsed = new Date(year, month, day);
    if (
      parsed.getFullYear() !== year ||
      parsed.getMonth() !== month ||
      parsed.getDate() !== day
    ) {
      return null;
    }
    return parsed;
  }

  const fallback = new Date(str);
  if (Number.isNaN(fallback.getTime())) return null;
  return new Date(
    fallback.getFullYear(),
    fallback.getMonth(),
    fallback.getDate(),
  );
}

export function getBannerId(banner) {
  return banner?.id ?? banner?._id ?? null;
}

/** Extrait et trie la liste depuis la réponse bannersService.getBanners(). */
export function normalizeBannersList(bannersData) {
  if (!bannersData?.success) return [];
  const raw = bannersData.data;
  const list = Array.isArray(raw) ? raw : raw?.data ?? [];
  return [...(list || [])].sort(
    (a, b) => (a.position ?? 0) - (b.position ?? 0),
  );
}

/**
 * Bannière affichable aujourd'hui (active + fenêtre startDate / endDate).
 * endDate null = pas de date de fin.
 */
export function isBannerVisible(banner, now = new Date()) {
  if (!banner || banner.isActive !== true) return false;

  const today = parseBannerDate(now);
  if (!today) return false;

  if (banner.startDate) {
    const start = parseBannerDate(banner.startDate);
    if (!start || today < start) return false;
  }

  if (banner.endDate != null && banner.endDate !== '') {
    const end = parseBannerDate(banner.endDate);
    if (!end || today > end) return false;
  }

  return true;
}
